import { gql } from '@apollo/client'

export const REMOVE_PUSH_TOKEN = gql`
  mutation RemovePushToken($push_token_id: Int!) {
    removePushToken(push_token_id: $push_token_id) {
      push_token_id
      device_name
      platform
    }
  }
`
